import { useIsMobile } from 'pricing-pages-lib/js/context/IsMobileContext.tsx';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { setExperimentEligibility } from '../../actions/ExperimentationActions';
import { SSM0009_GROUP_PARAMETER_KEY, SSM0009_GROUP_PARAMETER_OPTIONS, SSM0009_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useAppDispatch, useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { areExperimentsLoadingSelector, experimentByTreatmentKeySelector, hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { laboratoryClient } from '../laboratoryClient';
import { getIsAcceptanceTest } from '../testUtils';
const treatmentKey = SSM0009_TREATMENT_KEY;
const groupParameterKey = SSM0009_GROUP_PARAMETER_KEY;
const groupParameterOptions = SSM0009_GROUP_PARAMETER_OPTIONS;
export const logSSM0009Exposure = () => {
  laboratoryClient.logExposure(treatmentKey);
};
export const useSSM0009Experiment = () => {
  const isAcceptanceTest = getIsAcceptanceTest();
  const experiment = useAppSelector(state => experimentByTreatmentKeySelector(state, treatmentKey));
  const areExperimentsLoading = useAppSelector(areExperimentsLoadingSelector);
  const hasExperimentsFetchSucceeded = useAppSelector(hasExperimentsFetchSucceededSelector);
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isMobile = useIsMobile();

  // Public experiment
  const isEligible = hasExperimentsFetchSucceeded && !isAppAuth && !isMobile && !isAcceptanceTest;
  const isControl = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === groupParameterOptions.control;
  const isVariant = isEligible && (experiment === null || experiment === void 0 ? void 0 : experiment.parameters[groupParameterKey]) === groupParameterOptions.variant;
  const isHideStarter = new URLSearchParams(window.location.search).get('hide_starter') === 'true' && isVariant;
  return {
    isEligibleForSSM0009: isEligible,
    isSSM0009Control: isControl,
    isSSM0009Variant: isVariant,
    isSSM0009Fetched: hasExperimentsFetchSucceeded,
    isSSM0009Loading: areExperimentsLoading,
    isSSM0009HideStarter: isHideStarter
  };
};

// Hook for logging exposure and returning experiment data
export const useSSM0009ExperimentEffect = () => {
  const experiment = useSSM0009Experiment();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (experiment.isEligibleForSSM0009) {
      logSSM0009Exposure();
      dispatch(setExperimentEligibility({
        treatmentKey: SSM0009_TREATMENT_KEY,
        isEligible: true,
        group: experiment.isSSM0009Control ? 'control' : 'variant',
        isPublic: true,
        isInApp: false
      }));
    }
  }, [experiment.isEligibleForSSM0009, dispatch, experiment.isSSM0009Control]);
  return experiment;
};

// logic that persists/removes the hide_starter query param,
// persists/removes the data in sessionStorage,
// and adjusts the URL accordingly
export const useSSM0009HideStarterEffect = (isSSM0009Variant, additionalDependency) => {
  const history = useHistory();
  useEffect(() => {
    if (isSSM0009Variant) {
      const params = new URLSearchParams(window.location.search);
      const hideStarterParam = params.get('hide_starter');
      const sessionStoredHideStarter = JSON.parse(sessionStorage.getItem('hide_starter') || 'null');
      if (sessionStoredHideStarter && hideStarterParam === null) {
        params.append('hide_starter', 'true');
        history.replace({
          search: params.toString()
        });
      } else if (sessionStoredHideStarter && hideStarterParam === 'false') {
        sessionStorage.removeItem('hide_starter');
      } else if (hideStarterParam === 'true' && !sessionStoredHideStarter) {
        sessionStorage.setItem('hide_starter', 'true');
      }
    }
  }, [isSSM0009Variant, history, additionalDependency]);
};